module.exports = __webpack_public_path__ + "static/img/closeEyes.6cc6e1ca.svg";